import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressType } from 'src/app/core/enums';
import { CommonAddressResponse } from 'src/app/core/models/CommonAddressResponse';
import { CXMCustomerAddressResponse } from 'src/app/core/models/CXMCustomerAddressResponse';
import { UserService } from 'src/app/core/user/user.service';
import * as _ from 'lodash';
import { UserQuery } from 'src/app/core/user/user.query';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ChannelService } from 'src/app/home/channel/channel.service';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.scss']
})
export class AddressListComponent implements OnInit {
  @Input() savedAddress: CXMCustomerAddressResponse[];
  @Input() isCartPage : boolean;
  @Input() isProfilePage: boolean;
  @Output() displayAddAddressForm = new EventEmitter();
  @Output() editSelectedAddress = new EventEmitter();
  @Output() outputSelectedAddress = new EventEmitter();

  addressType = AddressType;
  selectedAddress: CommonAddressResponse;
  addressSub$: Subscription = new Subscription();

  constructor(
    private userService: UserService,
    private userQuery: UserQuery,
    private navigationService: NavigationService,
    private channelService: ChannelService,
  ) {}

  ngOnInit(): void {
    this.addressSub$ = this.userQuery.selectedAddress$.subscribe(address => {
      this.selectedAddress = address;
    });
  }

  addNewAddress() {
    if(this.isProfilePage){
      this.navigationService.navigate(['account', 'address', 'new-address']);
    }else{
      this.displayAddAddressForm.emit(true);
    }
  }

  editAddress(address: CXMCustomerAddressResponse) {
    this.editSelectedAddress.emit(address);
  }

  selectAddres(address: CXMCustomerAddressResponse) {
    let pathSegments = this.channelService.getSegments();

    const addressData = {
      type: address.addrSysFlag,
      addressId: address.addressId + '',
      addressDesc: address.addressDesc,
      unit: address.unitNo,
      postalCode: address.delAddPostal,
      city: address.delAddCity,
      country: null,
      countryShortName: address.delCountryCode,
      fullAddress: address.delAddress,
      longitude: address.longitude,
      latitude: address.latitude,
      remarks: address.remarks,
      addressSubscriptionTag : pathSegments[0] ?? null
    };

    localStorage.setItem('recent-address', JSON.stringify(this.selectedAddress));
    this.userService.updateSelectedAddress(addressData);

    this.outputSelectedAddress.emit(addressData);
  }

  ngOnDestroy() {
    this.addressSub$?.unsubscribe();
  }
}
